import { type MessageDeliveryStatusEnum } from '@novu/shared';
import { Tooltip, TooltipContent, TooltipPortal, TooltipTrigger } from '@/components/primitives/tooltip';
import { StatusBadge as StatusBadgeComponent, StatusBadgeIcon } from '../../primitives/status-badge';
import { DELIVERY_STATUS_CONFIG } from '../constants';
import { getPrimaryDeliveryStatus } from '../helpers';

export interface DeliveryStatusBadgeProps {
  deliveryStatus?: MessageDeliveryStatusEnum[];
}

export function DeliveryStatusBadge({ deliveryStatus }: DeliveryStatusBadgeProps) {
  const primaryStatus = getPrimaryDeliveryStatus(deliveryStatus);

  if (!primaryStatus) return null;

  const { variant, icon: Icon, label } = DELIVERY_STATUS_CONFIG[primaryStatus];

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span>
          <StatusBadgeComponent variant="stroke" status={variant} className="h-4 w-4 border-0 px-0 ring-0">
            <StatusBadgeIcon as={Icon} />
          </StatusBadgeComponent>
        </span>
      </TooltipTrigger>
      <TooltipPortal>
        <TooltipContent>{label}</TooltipContent>
      </TooltipPortal>
    </Tooltip>
  );
}
